export default "__VITE_ASSET__CRJ8b_PE__"